import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setHours(24, 0, 0, 0);
      const difference = tomorrow.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-lg px-3 md:px-4 py-1.5 md:py-2 mb-4 md:mb-6" data-id="element-60">
      <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-red-400" data-id="element-61" />
      <span className="text-red-300 text-xs md:text-sm font-medium" data-id="element-62">
        La oferta termina en:{' '}
        <span className="text-white font-mono font-bold" data-id="element-63">
          {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
          {formatTime(timeLeft.seconds)}
        </span>
      </span>
    </div>;
}